import { BadgeData } from './types';
import { StyledCornerBadge } from './style';
import { EBadgePosition, EBadgeType } from 'utils/enums';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

function Badge({
  type,
  position,
  emblem,
  ribbon,
  badge,
  className,
}: BadgeData & { position?: EBadgePosition }) {
  const emblemPic = emblem?.imageUrl || badge?.emblem?.imageUrl;
  const ribbonText = ribbon?.text || badge?.ribbon?.text;
  const background = emblemPic && `url(${emblemPic})`;
  const isSmallBadge = className === 'saleBadge small';

  return (
    <StyledCornerBadge
      className={className}
      background={
        type === EBadgeType.SALE
          ? 'url(https://media.appcharge.com/defaults/sale-ribbon-huge.png)'
          : background
      }
      textColor={ribbon?.textColor || badge?.ribbon?.textColor}
      position={position || badge?.position}
    >
      {ribbonText && (
        <div className="sale-amount">
          <AutoTextSize
            maxFontSizePx={isSmallBadge ? 12 : 15}
            minFontSizePx={6}
            as="p"
            mode="oneline"
          >
            {ribbonText?.substring(0, 5)}
          </AutoTextSize>
        </div>
      )}
    </StyledCornerBadge>
  );
}

export default Badge;
